var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2777 0.444428C25.6319 0.444428 26.7777 1.59026 26.7777 2.94443C26.7777 3.77776 26.361 4.50693 25.736 4.97568L14.4339 13.4653C13.8089 13.934 13.0277 13.934 12.4027 13.4653L1.10061 4.97568C0.475606 4.50693 0.111023 3.77776 0.111023 2.94443C0.111023 1.59026 1.20477 0.444428 2.61102 0.444428H24.2777ZM11.4131 14.8194C12.611 15.7048 14.2256 15.7048 15.4235 14.8194L26.7777 6.27776V17.1111C26.7777 18.9861 25.2673 20.4444 23.4444 20.4444H3.44436C1.56936 20.4444 0.111023 18.9861 0.111023 17.1111V6.27776L11.4131 14.8194Z",
    fill: "#C10100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/mail_icon.bdf6705ef76df61df92a7f63003c82fa.svg";
export { ForwardRef as ReactComponent };